import {useEvent} from 'Event/EventProvider'
import {eventRoutes} from 'Event/Routes'
import {isInTest} from 'env'
import {useEffect} from 'react'
import ReactGA from 'react-ga4'
import {UaEventOptions} from 'react-ga4/types/ga4'

const GA_4_MEASUREMENT_ID = 'G-EVPND5CMBP'

export function useAnalytics() {
  useEffect(() => {
    if (isInTest) {
      return
    }

    if (window.location.pathname.endsWith(eventRoutes.emoji_page)) {
      return
    }

    ReactGA.initialize(GA_4_MEASUREMENT_ID)

    // Track Load Performance
    const callback: PerformanceObserverCallback = (list) => {
      list.getEntries().forEach((entry: any) => {
        ReactGA.send({
          hitType: 'timing',
          category: 'Load Performace',
          variable: 'Server Latency',
          value: entry.responseStart - entry.requestStart,
        })

        ReactGA.send({
          hitType: 'timing',
          category: 'Load Performace',
          variable: 'Download Time',
          value: entry.responseEnd - entry.responseStart,
        })

        ReactGA.send({
          hitType: 'timing',
          category: 'Load Performace',
          variable: 'Total App Load',
          value: entry.responseEnd - entry.requestStart,
        })
      })
    }

    try {
      const loadObserver = new PerformanceObserver(callback)
      loadObserver.observe({entryTypes: ['navigation']})
    } catch {
      // Ignore errors, failing to load PerformanceObserver on iOS
      // not break the app.
    }
  }, [])
}

/**
 * Record a page view in analytics
 */
export function usePageView(page?: string) {
  useEffect(() => {
    if (isInTest) {
      return
    }

    const url = window.location.pathname + window.location.search
    const location = page || url
    ReactGA.send({
      hitType: 'pageview',
      page: location,
    })
  }, [page])
}

const recordEvent = (data: UaEventOptions) => {
  if (isInTest) {
    return
  }
  ReactGA.event(data)
}

/**
 * Send an event to Google Analytics
 * @returns
 */
export function useTrackOnLoad(data: {
  category: string
  action: string
  label?: string
  value?: number
}) {
  useEffect(() => {
    recordEvent(data)
  }, [data])
}

export function useTrackEventPage(data: {
  page: string
  details?: string
  value?: number
}) {
  const {event} = useEvent()
  const {page, details, value} = data

  useTrackOnLoad({
    category: `Event - ${event.name} (${event.slug})`,
    action: page,
    label: details,
    value,
  })
}

export function sendTiming(data: {
  category: string
  variable: string
  value: number
  label?: string
}) {
  if (isInTest) {
    return
  }

  ReactGA.send({
    hitType: 'timing',
    category: data.category,
    variable: data.variable,
    value: data.value,
    label: data.label,
  })
}

export const recordHostJoin = (roomId: number) =>
  recordEvent({
    category: 'Admin',
    action: 'Host Joined',
    value: roomId,
  })
